const normalize = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .trim();

const sectionByCheck = {
  endereco: 'address',
  'endereco do imovel': 'address',
  'registro e escritura': 'registry',
  laudemio: 'laudemio',
  valores: 'values',
  'prazo de escritura e/ou multa': 'deadline',
  clausulas: 'clauses',
  documentos: 'documents',
  'documentos do imovel': 'documents',
};

const checkName = check => check?.name || check?.nome || check;

export const salesPropertyReviewContext = transaction => {
  const item = (transaction?.review?.items || []).find(
    reviewItem => reviewItem.section === 'imovel'
  );
  const checks = item?.checks || [];
  const sectionChecks = checks.reduce((groups, check) => {
    const section = sectionByCheck[normalize(checkName(check))];
    if (section) groups[section] = [...(groups[section] || []), check];
    return groups;
  }, {});
  const sectionKeys = [
    ...new Set(
      checks
        .map(check => sectionByCheck[normalize(checkName(check))])
        .filter(Boolean)
    ),
  ];

  return {
    checks,
    hasCorrections: checks.length > 0,
    isComplete:
      item?.status === 'corrigido' ||
      (checks.length > 0 && checks.every(check => check.saved === true)),
    item,
    observation: item?.observation || '',
    sectionKeys,
    sectionChecks,
  };
};
